import * as Sentry from '@sentry/nuxt'
import packageJson from '../package.json'

export default defineNuxtPlugin((nuxtApp) => {
  Sentry.setTags({
    'versions.genesis': packageJson.version,
    'versions.nuxt': nuxtApp.versions.nuxt,
    'versions.vue': nuxtApp.versions.vue,
  })

  return {
    provide: {
      sentrySetContext: Sentry.setContext,
      sentrySetUser: Sentry.setUser,
      sentrySetTag: Sentry.setTag,
      sentryAddBreadcrumb: Sentry.addBreadcrumb,
      sentryCaptureException: Sentry.captureException,
      sentryCaptureMessage: Sentry.captureMessage,
    },
  }
})
